import {Component, HostBinding, Input, OnInit} from '@angular/core';

@Component({
  selector: 'awair-input-error',
  templateUrl: './input-error.component.html',
  styleUrls: ['./input-error.component.scss']
})

export class InputErrorComponent implements OnInit {
  @HostBinding('style.opacity') hostOpacity: number = 0;

  @Input() period: number = 3000;
  get message(): string {
    if (this._message != null && this._message !== '') {
      return this._message
    }
  }
  @Input()
  set message(value: string) {
    if (value != null && value !== '') {
      this.hostOpacity = 1;
      this._message = value;

      setTimeout(() => {
        this.hostOpacity = 0;
      }, this.period);
    } else {
      this.hostOpacity = 0;
      this._message = null;
    }
  }
  private _message: string;

  constructor() {
  }

  ngOnInit() {
  }
}
